import * as types from '../constants/ActionTypes';

const initialState = {
    token: null,
    userName: null,
    isAuthenticated: false,
    isAuthenticating: false,
    statusText: null
};

export default function auth(state = initialState, action) {
    const {type, payload} = action;
    switch (type) {
        case types.LOGIN_USER_REQUEST:
            return Object.assign({}, state, {
                'isAuthenticating': true,
                'statusText': null
            });

        case types.LOGIN_USER_SUCCESS:
            return Object.assign({}, state, {
                'isAuthenticating': false,
                'isAuthenticated': true,
                'token': payload.token,
                'userName': payload.userName
            });

        case types.LOGIN_USER_FAILURE:
            let statusText = 'Authentication Error: incorrect email or password';
            if (payload.status !== 401) {
               statusText = `Authentication Error: ${payload.status} ${payload.statusText}`;
            }
            return Object.assign({}, state, {
                'isAuthenticating': false,
                'isAuthenticated': false,
                'token': null,
                'userName': null,
                'statusText': statusText
            });

        case types.LOGOUT_USER:
            return Object.assign({}, state, {
                'isAuthenticated': false,
                'token': null,
                'userName': null
            });

        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/reducers/auth.js